/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { AbstractControl } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

/**
 *
 * @param control Control that has the validatior defined
 * @param form Complete form
 * @param options A validation function specific option object. Example:
 * @returns true if validation passed. An object with the validation id and a message property 
 * inside if failed. Example: { "date": { message: "Something went wrong"}}
 */
export function decimalMaxValidator(
  control: AbstractControl,
  form: FormlyFieldConfig,
  options: any = {}
) {
  const model = control.value;
  let errormsg = '';
  // Condition Checked for object(props.min) throws undefined issue
  if(form.props?.maxDecimalNum){
    // Check given value gretaer than max value
    const maxValue: number = +form.props.maxDecimalNum;
    const isInclusive = (options && options.inclusive && options.inclusive === true) ? true : false;

    // Maximum value can be inclusive / exclusive. By default it's exclusive
    let errorCondition: boolean = false;
    if (isInclusive) {
      errorCondition = (+model > maxValue);
    } else {
      errorCondition = (+model >= maxValue);
    }

    if (errorCondition){
      if (isInclusive) {
        errormsg = "Value should be less than or equal to "+ form.props.maxDecimalNum;
      } else {
        errormsg = "Value should be less than "+ form.props.maxDecimalNum;
      }
    }
  }

  return errormsg
  ? {
      decimalMaxValidator: {
        message: errormsg,
      },
    }
  : null;
}